import React from 'react'
import DateHelper from '../../../utils/DateHelper'
import UtilHelper from '../../../utils/UtilHelper'
import EmptyState from '../../../newComponents/emptystate'
import BasicDetailCard from './BasicDetailCard'
import { GetImages } from '../../../utils/GetImages'
import { TextCss } from '../../GlobalCss/TextCss'

const EmploymentHistoryInfo = ({ EmploymentHistory }) => {

  return (
    <>
      {EmploymentHistory?.length ? (
        EmploymentHistory?.map((item, i) => (
          <div key={i} className="Employment_history_main emp_item">
            
            <div className='Employment_history_first_Section '>
              <div className="rentpay-avatar"><img className='color-white-icon' src={GetImages.Company} /></div>
              <div className='flexColumn gap-2'>
              <p className={TextCss.black.heading_700_16}>{item?.name}</p>
              <p className="listing-type">
               {item?.firstName} {item?.lastName} • {item?.email} • {UtilHelper.formatPhoneForDisplay(item?.phoneNumber)}
                      </p>
             </div>
            </div>
            <div className='Employment_history_Second_Section d-flex justify-content-between'>
              <div className="flexRowCenter gap-2">
                          <div className="p-2 flexColumnCenter ">
                            <p className="normal_text fw-700 black">{DateHelper.convertUTCtoDateTimeSimple(item?.startDate)}</p>
                            <p className="normal_text ">Start Date</p>
                          </div>
                          
                          <div className="p-2 flexColumnCenter BorderLeft">
                            <p className="normal_text fw-700 black">{DateHelper.convertUTCtoDateTimeSimple(item?.endDate)}</p>
                            <p className="normal_text ">End Date</p>
                          </div>
                        </div>
              
              {/* <BasicDetailCard textClass="sub_text" firstName={item?.firstName} lastName={item?.lastName} email={item?.email} phoneNumber={item?.phoneNumber} /> */}
            </div>
          </div>
        ))
      ) : (<EmptyState heading="Data not found" isButton={false} isBorder={false} />)}
    </>
  )
}

export default EmploymentHistoryInfo